// extracted by mini-css-extract-plugin
export default {"overlay":"nv-z","bodyOpen":"ov-z","content":"pv-z","header":"qv-z","close":"rv-z","closeNoHeading":"sv-z"};